document.addEventListener("DOMContentLoaded", function () {
  const accordionSection = document.querySelector('.accordion-section');

  if (!accordionSection) return;

  const accordionItems = accordionSection.querySelectorAll('.accordion-item');

  accordionItems.forEach(item => {
    const title = item.querySelector('.accordion-title');

    title.addEventListener('click', () => {
      const isOpen = item.classList.contains('active');

      accordionItems.forEach(i => {
        i.classList.remove('active');
        i.querySelector('.accordion-content').style.maxHeight = null;
      });

      if (!isOpen) {
        item.classList.add('active');
        const content = item.querySelector('.accordion-content');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
});